import React, { useContext, useState } from "react";
import Button from "../../../../components/ButtonComponent/Button";
import { SideMenu } from "../../../../components/sideMenu/SideMenu";
import { OrderDetailContext } from "../OrderDetailView";
import Spinner from "../../../../components/spinner/Spinner";
import ConfirmBox from "../../../../components/confirmationModal/ConfirmBox";
import AlertBox from "../../../../components/alertComponent/AlertBox";
import "./OrderDetail.css";
import Popup from "../../../../components/popupComponent/popUp";
import InputText from "../../../../components/TextComponent/textInput";

const OrderDetail = () => {
  const {
    textContents,
    orderDetails,
    visibleConfirm,
    setVisibleConfirm,
    showAlert,
    setShowAlert,
    alertMessage,
    logout,
    confirmMessage,
    setConfirmMessage,
    btnAcceptClick,
    btnRejectClick,
    updateStatus,
    setUpdateStatus,
    showLogoutAlert,
    setShowLogoutAlert,
    logoutConstants,
    logoutAlertMessage,
    processStatus,
    pageTitle,
    apiStatus,
    setShowPopup,
    showPopup,
    shareHistory,
    driverMobileNumber,
    handleInputChange,
    handleOnChangeMobile,
    mobileEnterMessage,
    handleClose,
    popUpMessages,
    successAlert,
    setSuccessAlert,
    errorAlert,
    setErrorAlert,
    isZonalHead,
    freightType,
    toLoginPage,
    pageIsOrderDetail,
    dataFromHistory,
  } = useContext(OrderDetailContext);

  return (
    <div className="mainContainerDetail">
      <SideMenu />

      <div className="itemBoxDetail">
        <div className="col-xl-11 col-lg-11 col-md-12 col-sm-12 col-10 mainBoxDetail">
          {/* ✅ GLOBAL SPINNER */}
          {apiStatus === "fetching" ? (
            <div className="spinnerContainer">
              <Spinner />
            </div>
          ) : (
            <>
              <h5 className="titleDetail">{pageTitle}</h5>

              {orderDetails ? (
                <>
                  <div className="statusDetailContainer">
                    <p className="statusDetail">
                      <span className="statusTitle">{textContents.status}</span>{" "}
                      <span>:</span>{" "}
                      <span
                        className={
                          orderDetails.intent_status ==
                          textContents?.successData
                            ? "statusTextActive1"
                            : orderDetails.intent_status ==
                                textContents?.completedData
                              ? "statusTextCompleted"
                              : orderDetails.intent_status ==
                                  textContents?.activeData
                                ? "statusTextPending1"
                                : orderDetails.intent_status ==
                                    textContents?.rejectData
                                  ? "statusTextReject1"
                                  : "statusTextCancel1"
                        }
                      >
                        {processStatus(orderDetails.intent_status)}
                      </span>
                    </p>
                  </div>

                  <div className="col-xl-12 col-lg-12 col-md-12 listBox">
                    <div className="row">
                      <div className="col-xl-3 col-lg-4 col-md-4 dataCard">
                        <p className="fieldTitle">
                          {textContents.freightOrder}
                        </p>
                        <p className="fieldData">{orderDetails.sap_id}</p>
                      </div>

                      <div className="col-xl-3 col-lg-4 col-md-4 dataCard">
                        <p className="fieldTitle">{textContents.sourceName}</p>
                        <p className="fieldData">{orderDetails.source_name}</p>
                      </div>

                      <div className="col-xl-3 col-lg-4 col-md-4 dataCard">
                        <p className="fieldTitle">{textContents.sourceCity}</p>
                        <p className="fieldData">{orderDetails.source_city}</p>
                      </div>

                      <div className="col-xl-3 col-lg-4 col-md-4 dataCard">
                        <p className="fieldTitle">
                          {textContents.destinationName}
                        </p>
                        <p className="fieldData">
                          {orderDetails.destination_name}
                        </p>
                      </div>

                      <div className="col-xl-3 col-lg-4 col-md-4 dataCardLast">
                        <p className="fieldTitle">
                          {textContents.destinationCity}
                        </p>
                        <p className="fieldData">
                          {orderDetails.destination_city}
                        </p>
                      </div>

                      <div className="col-xl-3 col-lg-4 col-md-4 dataCardLast">
                        <p className="fieldTitle">{textContents.vehicleType}</p>
                        <p className="fieldData">{orderDetails.truck_type}</p>
                      </div>

                      <div className="col-xl-3 col-lg-4 col-md-4 dataCardLast">
                        <p className="fieldTitle">{textContents.dateTime}</p>
                        <p className="fieldData">
                          {orderDetails.requirement_date}{" "}
                          {orderDetails.requirement_time}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="emptyContainer">
                  <div className="nodataText">No Data Found</div>
                </div>
              )}

              <div></div>

              <div className="zonalSection">
                {isZonalHead &&
                orderDetails?.intent_status !== textContents?.completedData ? (
                  <div className="zonalHeadSection">
                    <h3>{textContents.driverMobile}</h3>

                    <div className="inputDataZonal">
                      <InputText
                        type="text"
                        placeholder="Enter mobile number"
                        value={driverMobileNumber}
                        onChange={handleInputChange}
                        className="w-full p-2 border rounded mb-4"
                      />

                      <Button
                        text="Send Link"
                        className="zonalSendingBtn"
                        onClick={() => handleOnChangeMobile(driverMobileNumber)}
                      />
                    </div>

                    {mobileEnterMessage && (
                      <div className="messageColor">{mobileEnterMessage}</div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                {freightType == "IFO" && (
                  <div>
                    <div className="zonalHistory">
                      <h3>{textContents.linkHistory}</h3>

                      <div className="historyData">
                        <div className="flexData">
                          <h4>{textContents.driverMobile}</h4>
                          <h4>{textContents?.status}</h4>
                        </div>

                        {shareHistory.length == 0 ? (
                          <div className="noDataMessage">No Data Found</div>
                        ) : (
                          shareHistory.map((data, index) => (
                            <div className="flexData" key={index}>
                              <div className="numberByDriver">
                                {data.driver_mobile}

                                <div className="numberByDriver">
                                  {data.gate_in_date_time &&
                                  data.gate_out_date_time ? (
                                    <>
                                      <span>
                                        Gate In: {data.gate_in_date_time}
                                      </span>
                                      <br />
                                      <span>
                                        Gate Out: {data.gate_out_date_time}
                                      </span>
                                    </>
                                  ) : (
                                    <span>
                                      Created Date: {data.created_date}
                                    </span>
                                  )}
                                </div>
                              </div>

                              <div
                                className={
                                  "statusByDriver " +
                                  (data.status === textContents?.completedData
                                    ? "statusTextActive1"
                                    : data.status === textContents?.gateInData
                                      ? "statusTextCompleted"
                                      : data.status === textContents?.cancelData
                                        ? "statusTextReject1"
                                        : "statusTextCancel1")
                                }
                              >
                                {data.status}
                              </div>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {orderDetails?.intent_status === "Active" && !isZonalHead ? (
                <div className="buttonContainerDetails">
                  <div className="buttonContainerReject">
                    <Button
                      text={textContents.reject}
                      onClick={() => {
                        setConfirmMessage(textContents.confirmReject);
                        setUpdateStatus("Reject");
                        setVisibleConfirm(true);
                      }}
                    />
                  </div>

                  <div className="buttonContainerAccept">
                    <Button
                      text={textContents.accept}
                      onClick={() => {
                        setConfirmMessage(textContents.confirmAccept);
                        setUpdateStatus("Success");
                        setVisibleConfirm(true);
                      }}
                    />
                  </div>
                </div>
              ) : orderDetails?.intent_status === "Success" &&
                (freightType === "IFO" ||
                  dataFromHistory?.freight_type === "IFO") &&
                !isZonalHead ? (
                <div className="sendLinkBtns">
                  <Button
                    text={textContents.sendLinkText}
                    onClick={() => setShowPopup(true)}
                  />
                </div>
              ) : null}
            </>
          )}
        </div>

        {/* POPUPS (unchanged) */}
        <ConfirmBox
          show={visibleConfirm}
          setShow={setVisibleConfirm}
          confirmMessage={confirmMessage}
          confirmFunc={
            updateStatus == "Success"
              ? () => btnAcceptClick(orderDetails.intent_id, "1")
              : updateStatus == "Reject"
                ? () => btnRejectClick(orderDetails.intent_id, "0")
                : null
          }
        />

        <AlertBox
          show={showAlert}
          setShow={setShowAlert}
          title={textContents.alert}
          alertMessage={alertMessage}
          buttonSubmitText={"LOGIN"}
          alertFunc={logout}
        />

        <AlertBox
          show={showLogoutAlert}
          setShow={setShowLogoutAlert}
          title={logoutConstants.alert}
          alertMessage={logoutAlertMessage}
          okFunction={toLoginPage}
        />

        <AlertBox
          show={successAlert}
          setShow={setSuccessAlert}
          title={"Success"}
          alertMessage={popUpMessages}
        />

        <AlertBox
          show={errorAlert}
          setShow={setErrorAlert}
          title={"Error"}
          alertMessage={popUpMessages}
        />

        <Popup
          show={showPopup}
          setShow={setShowPopup}
          value={driverMobileNumber}
          onChange={handleInputChange}
          sendLinkBtn={() => handleOnChangeMobile(driverMobileNumber)}
          validationMessage={mobileEnterMessage}
          handleClose={handleClose}
        />
      </div>
    </div>
  );
};

export default OrderDetail;
